import { TXCenter } from '@/api/apis/facilities';
import { CustomerInTxCenterForm } from '@/types/customer';
import { SelectItemType } from '@/types';

type TxCenterListItem = SelectItemType & { data?: TXCenter };

export const getCombinedTxCenterList = (
  customerInTxCenters: CustomerInTxCenterForm[] | undefined,
  infiniteDropdownTxCentersList: TxCenterListItem[],
): TxCenterListItem[] => {
  if (!customerInTxCenters?.length) {
    return infiniteDropdownTxCentersList;
  }

  const selectedTxCenters = customerInTxCenters
    .map((c) =>
      c.txCenter
        ? ({
            name: c.txCenter.name,
            value: c.txCenter.id,
            data: c.txCenter,
          } as TxCenterListItem)
        : null,
    )
    .filter((c): c is TxCenterListItem => !!c);

  const filteredCenters = infiniteDropdownTxCentersList.filter(
    (a) => !selectedTxCenters.some((t) => t.value === a.value),
  );

  return [...selectedTxCenters, ...filteredCenters];
};

export const getUpdatedCustomerInTxCenters = (
  selectedIDs: string[],
  currentCenters: CustomerInTxCenterForm[],
  list: TxCenterListItem[],
): CustomerInTxCenterForm[] => {
  return selectedIDs.map((txCenterId) => {
    const existing = currentCenters.find((c) => c.txCenterId === txCenterId);
    if (existing) {
      return existing;
    }

    const txCenter = list.find((t) => t.value === txCenterId)?.data;

    return {
      txCenterId,
      roles: [],
      isPrimary: false,
      txCenter,
    } as CustomerInTxCenterForm;
  });
};

export const sortSelectedItems = (items: Array<{ data?: TxCenterListItem | null }>): SelectItemType[] => {
  return [...items]
    .sort((a, b) => {
      const nameA = a.data?.name || '';
      const nameB = b.data?.name || '';
      return nameA.localeCompare(nameB);
    })
    .map((item) => item.data as SelectItemType);
};
